import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Angular",
    "TypeScript",
    "JavaScript",
    "NoSQL",
    "Firebase API",
    "Fast API",
    "Python",
    "Nodejs",
    "SQL",
    "PostgreSQL",
    "Postman"
];

const labelsSecond = [
    "AWS",
    "Azure",
    "Linux",
    "Git",
    "GitHub Actions",
    "Ansible",
    "Chef",
    "Prometheus",
    "Grafana",
    "Datadog",
    "JMeter",
    "Cypress",
    "Selenium",
    "Docker",
    "Kubernets",
    "Terraform",
    "Jenkins",
];

const labelsThird = [
    "Pandas",
    "ScitKit",
    "Matplotlib",
    "Numpy",
    "OpenAI",
    "Grok",
    "LangChain",
    "Quicksight",
    "Tableau",
    "Hugging Face",
    "LlamaIndex",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Web Development</h3>
                    <p>I have developed a wide range of web applications from the ground up using modern technologies like React for the frontend and Flask, Node.js, and AWS Lambda for the backend. I have a deep understanding of the software development lifecycle (SDLC) and strong expertise in both frontend and backend development.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>After building the application, I assist clients in establishing a robust DevOps workflow, including setting up automated testing, configuring CI/CD pipelines, and implementing deployment automation. This ensures a seamless and efficient transition to production, minimizing downtime and optimizing performance for a successful Go-Live.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Data Science & LLM</h3>
                    <p>Stay ahead in the industry by integrating AI, data science, and analytics into your projects. I have experience building enterprise-grade solutions using Generative AI (GenAI) and large language models (LLMs) to enhance intelligent decision-making and optimize business processes.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;